import { render, staticRenderFns } from "./ExamenNuevo.vue?vue&type=template&id=55804858&"
import script from "./ExamenNuevo.vue?vue&type=script&lang=js&"
export * from "./ExamenNuevo.vue?vue&type=script&lang=js&"
import style0 from "./ExamenNuevo.vue?vue&type=style&index=0&id=55804858&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports